export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '凌晨三点的城市：那些不为人知的夜间故事',
    excerpt: '当整座城市陷入沉睡，总有一些人在黑暗中书写着属于他们的故事。我们用镜头和文字，记录下凌晨三点城市最真实的模样。',
    content: `<p>凌晨三点，是一座城市最安静也最真实的时刻。</p>
<p>街道上的霓虹灯还在闪烁，但行人已经寥寥无几。24小时便利店的灯光，像是黑夜中的灯塔，为夜归人提供着最后一丝温暖。</p>
<p><strong>深夜的便利店</strong></p>
<p>凌晨两点的便利店，收银员小陈正在整理货架。这是他在这里工作的第三个年头，已经习惯了黑白颠倒的生活。"夜晚的顾客和白天完全不同，"他说，"深夜来的人，大多带着故事。"</p>
<p>有人失恋买醉后踉跄而来，有人加班到深夜只为买一包泡面，也有无家可归者在角落里取暖。每一个深夜踏入便利店的人，都是这座城市夜色的注脚。</p>
<p><strong>深夜出租车司机</strong></p>
<p>老王开了二十年出租车，最喜欢的还是夜班。"晚上不堵车，乘客也少，但每个上车的都是有故事的人。"他遇到过在车上痛哭的年轻人，遇到过赶去医院的家属，也遇到过在车上求婚成功的情侣。</p>
<p>夜色是一层保护色，让人卸下白天的伪装，展现最真实的一面。</p>
<p><strong>夜班的守护者</strong></p>
<p>医院的急诊室、消防站的值班室、街角的派出所——这些地方24小时亮着灯。深夜值班的人们，是这座城市最沉默的守护者。</p>
<p>"习惯了，就不觉得累了，"一位急诊科医生说，"看到天亮的那一刻，会觉得一切都值得。"</p>
<p>凌晨三点，城市在做梦，而这些人在守护着梦。</p>`,
    category: 'night-life',
    categoryName: '夜间生活',
    author: '夜行者阿城',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20rim%20lighting%2C%20moody%20atmospheric%20profile%2C%20deep%20black%20background%2C%20golden%20edge%20light%2C%20cinematic%20portrait%20photography&width=200&height=200&seq=avatar-1&orientation=squarish',
    publishDate: '2026-08-10',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20city%20street%20at%203am%20with%20neon%20signs%20and%20warm%20streetlights%2C%20empty%20wet%20pavement%20reflecting%20lights%2C%20moody%20atmospheric%20urban%20night%20photography%2C%20deep%20shadows%20with%20amber%20and%20golden%20highlights%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-1&orientation=landscape',
    tags: ['城市夜生活', '深夜故事', '夜间工作者'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '夜幕下的灵感：为什么最好的创意诞生在深夜',
    excerpt: '从古至今，无数伟大的作品诞生于深夜。深夜为什么能激发创意？科学家和艺术家给出了他们的答案。',
    content: `<p>你有没有发现，很多最棒的灵感都出现在夜深人静的时候？</p>
<p>这不是巧合。从达芬奇到村上春树，从特斯拉到乔布斯，历史上无数创造者都是夜猫子。</p>
<p><strong>科学解释：为什么深夜更容易产生创意</strong></p>
<p>研究表明，人在疲倦时，前额叶皮层（负责逻辑和过滤的脑区）活动减弱，而默认模式网络（与联想和创造力相关）更加活跃。这就是为什么深夜的大脑更容易产生非线性的、创造性的联想。</p>
<p>深夜的安静环境还减少了外部干扰，让人更容易进入"心流"状态。</p>
<p><strong>艺术家们的夜间仪式</strong></p>
<p>日本作家村上春树每天凌晨四点起床写作；画家毕加索常常通宵作画，直到天亮才入睡；音乐家贝多芬习惯在深夜作曲，认为那时的灵感最为充沛。</p>
<p>这些创作者不约而同地选择了深夜，因为他们发现：当世界安静下来，内心的声音反而更加清晰。</p>
<p><strong>如何建立你的夜间创作习惯</strong></p>
<p>建立一个固定的夜间创作时段，让身体和大脑习惯这个节奏。关掉所有社交媒体的通知，创造一个无干扰的空间。准备一杯温热的饮品，调暗灯光，营造舒适的氛围。</p>
<p>最重要的是：不要强迫自己。深夜创作不是任务，而是一种享受。让灵感自然流淌，记录每一个闪光的瞬间。</p>`,
    category: 'creative-inspiration',
    categoryName: '创作灵感',
    author: '夜之灵感',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20golden%20rim%20lighting%2C%20artistic%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20amber%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish',
    publishDate: '2026-08-08',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20creative%20workspace%20at%20night%20with%20warm%20desk%20lamp%2C%20notebook%20and%20coffee%20on%20wooden%20desk%2C%20moody%20atmospheric%20artistic%20scene%2C%20deep%20shadows%20with%20golden%20light%20accents%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-2&orientation=landscape',
    tags: ['创作灵感', '夜间创作', '创意方法'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '深夜独处：学会与自己和解的五个夜晚',
    excerpt: '夜晚是最适合独处的时光。当我们卸下白天的面具，才能真正面对内心的声音。五个深度独处的夜晚练习，帮你找到内心的平静。',
    content: `<p>白天的我们，总是在扮演各种角色：员工、朋友、子女、伴侣……只有到了深夜，我们才真正属于自己。</p>
<p><strong>第一个夜晚：关掉所有屏幕</strong></p>
<p>选一个晚上，关掉手机、电脑、电视。最初的不适是正常的——我们已经习惯了用屏幕填满每一秒的空隙。但当你度过最初的不适后，你会发现世界突然变得很安静。</p>
<p>这种安静不是空虚，而是一种充盈。你开始听到自己的呼吸，感受到房间的温度，注意到窗外风吹树叶的声音。</p>
<p><strong>第二个夜晚：写下真实的感受</strong></p>
<p>准备一个本子和一支笔。不要打字——手写有一种电子设备无法替代的温度。写下任何出现在脑海中的想法，不要评判，不要编辑，只是记录。</p>
<p>你可能会惊讶于自己写下的东西。那些被日常掩盖的情绪，会在深夜悄悄浮现。</p>
<p><strong>第三个夜晚：深夜散步</strong></p>
<p>深夜的街道和白天的街道是两个不同的世界。穿上舒适的鞋子，在家附近走一走。感受夜晚的空气，观察那些白天被忽略的细节。</p>
<p>深夜散步有一种奇妙的治愈力。脚步的节奏会让纷乱的思绪慢慢沉淀。</p>
<p><strong>第四个夜晚：听完整的专辑</strong></p>
<p>选一张你一直想听但没时间听的专辑，从第一首听到最后一首。不做其他的事情，只是聆听。让音乐带你进入另一个世界。</p>
<p><strong>第五个夜晚：给自己写一封信</strong></p>
<p>写给一个月后的自己。写下此刻的心情、困惑、期待。一个月后打开这封信，你会看到一个更真实的自己。</p>`,
    category: 'late-night-emotion',
    categoryName: '深夜情绪',
    author: '夜之独白',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20copper%20rim%20lighting%2C%20contemplative%20moody%20profile%2C%20deep%20black%20background%2C%20soft%20warm%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-3&orientation=squarish',
    publishDate: '2026-08-06',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cozy%20bedroom%20at%20night%20with%20warm%20candlelight%2C%20journal%20and%20pen%20on%20bed%2C%20moody%20atmospheric%20self-care%20scene%2C%20deep%20shadows%20with%20soft%20amber%20glow%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-3&orientation=landscape',
    tags: ['深夜独处', '自我和解', '情绪管理'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '夜行者地图：全球十大最美夜景城市',
    excerpt: '从东京的霓虹海洋到巴黎的浪漫街灯，从纽约不夜城到冰岛的极光之夜——跟随夜行者地图，探索世界上最美的夜景。',
    content: `<p>每一座城市都有两张面孔：一张是白天的，一张是夜晚的。而夜晚的那张，往往更加迷人。</p>
<p><strong>1. 东京 · 霓虹海洋</strong></p>
<p>当夜幕降临，东京的涩谷十字路口变成世界上最壮观的灯光秀。成千上万的霓虹灯将夜空照亮，整个城市像一个巨大的电子梦境。</p>
<p><strong>2. 巴黎 · 光之城的浪漫</strong></p>
<p>埃菲尔铁塔在整点时刻的闪烁灯光秀，塞纳河畔的暖黄街灯，蒙马特高地俯瞰城市灯海——巴黎的夜晚，每一帧都像电影画面。</p>
<p><strong>3. 纽约 · 不夜城的脉搏</strong></p>
<p>时代广场的巨型屏幕永不熄灭，布鲁克林大桥上的夜景令人窒息。纽约的夜晚从不停歇，每一个转角都有新的故事。</p>
<p><strong>4. 冰岛 · 极光之舞</strong></p>
<p>在冰岛的冬夜，天空本身就是最美的灯光秀。绿色和紫色的极光在夜空中舞动，让人感觉置身于另一个星球。</p>
<p><strong>5. 香港 · 维港夜色</strong></p>
<p>维多利亚港两岸的摩天大楼上演着"幻彩咏香江"灯光秀。从太平山顶俯瞰，整个香港像一艘发光的巨轮。</p>
<p>每一座城市的夜晚，都是独一无二的艺术品。带上你的好奇心和相机，去探索属于你的夜行者地图吧。</p>`,
    category: 'night-life',
    categoryName: '夜间生活',
    author: '夜行者阿城',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20rim%20lighting%2C%20moody%20atmospheric%20profile%2C%20deep%20black%20background%2C%20golden%20edge%20light%2C%20cinematic%20portrait%20photography&width=200&height=200&seq=avatar-1&orientation=squarish',
    publishDate: '2026-08-04',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20aerial%20cityscape%20at%20night%20with%20countless%20warm%20city%20lights%2C%20beautiful%20nighttime%20skyline%20panorama%2C%20moody%20atmospheric%20urban%20photography%2C%20deep%20shadows%20with%20golden%20and%20amber%20light%20dots%2C%20cinematic%20composition&width=1200&height=600&seq=article-4&orientation=landscape',
    tags: ['城市夜景', '旅行', '夜景摄影'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '一个夜行者的自白：我为什么选择在夜晚生活',
    excerpt: '做了五年夜行者，有人问我：你为什么要过这种颠倒的生活？这篇文章，是我关于选择夜晚的全部理由。',
    content: `<p>凌晨四点，我刚写完今天的第三篇文章。窗外还是漆黑一片，但我知道，再过一小时，天就会开始亮了。</p>
<p>这是我做夜行者的第五年。</p>
<p><strong>为什么选择夜晚？</strong></p>
<p>很多人问我这个问题，答案其实很简单：夜晚给了我白天永远无法给予的东西——自由。</p>
<p>白天的世界太吵了。手机不停地震动，消息不断地涌入，每个人都在争夺你的注意力。但到了深夜，这些噪音会逐渐消失。你终于可以听到自己的声音。</p>
<p><strong>夜晚是诚实的</strong></p>
<p>在夜里，人会变得更加诚实。对别人诚实，也对自己诚实。那些白天被社交礼仪压制的真实想法，会在深夜悄悄浮出水面。</p>
<p>这也是为什么深夜的对话总是更加深刻。当世界安静下来，我们终于可以卸下伪装，说出那些藏在心底的话。</p>
<p><strong>夜晚是创造的</strong></p>
<p>我最好的文章都是在深夜写出来的。深夜有一种魔力，让思维变得更加自由。没有了白天的框架和期待，创意可以像野马一样奔跑。</p>
<p><strong>夜晚是治愈的</strong></p>
<p>当你经历了一天的疲惫和挫折，深夜是最好的疗愈时刻。一杯热茶，一首老歌，或者只是静静地坐着看窗外——这些简单的仪式，足以抚慰一天的疲惫。</p>
<p>做夜行者不是逃避白天，而是选择了一种更适合自己的生活方式。在夜晚，我终于找到了属于自己的节奏。</p>`,
    category: 'night-walker-community',
    categoryName: '夜行者社群',
    author: '深夜守望者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20bronze%20rim%20lighting%2C%20mysterious%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20golden%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-4&orientation=squarish',
    publishDate: '2026-08-02',
    readTime: '11分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20single%20warm%20desk%20lamp%20at%20night%2C%20coffee%20cup%20and%20open%20laptop%2C%20moody%20atmospheric%20night%20owl%20workspace%2C%20deep%20shadows%20with%20warm%20golden%20light%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-5&orientation=landscape',
    tags: ['夜行者生活', '生活方式', '自由'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '深夜食堂：五座城市最温暖的深夜美食',
    excerpt: '每一座不夜城都有属于自己的深夜食堂。从成都的串串到台北的豆浆，深夜美食不仅是味蕾的慰藉，更是心灵的栖息地。',
    content: `<p>深夜的胃，需要的不仅是食物，更是一种慰藉。</p>
<p><strong>成都 · 玉林路串串</strong></p>
<p>凌晨一点的玉林路，空气中弥漫着麻辣的香气。路边的串串店灯火通明，人们围坐在沸腾的锅底旁，一边涮着串串，一边聊着天。在这里，深夜从不孤独。</p>
<p><strong>台北 · 永和豆浆</strong></p>
<p>台北的夜晚，总有一家永和豆浆开着门。一碗热豆浆配上一根油条，简单却温暖。这是属于台北人的深夜仪式。</p>
<p><strong>东京 · 深夜拉面</strong></p>
<p>新宿小巷里的拉面店，凌晨两点还在排队。浓郁的豚骨汤底、弹牙的面条、半熟的溏心蛋——一碗拉面下肚，所有的疲惫都烟消云散。</p>
<p><strong>曼谷 · 考山路炒粉</strong></p>
<p>曼谷的夜生活从不缺少美食。炒河粉在铁板上滋滋作响，加上辣椒和青柠，酸辣鲜香在口中爆发。这是属于热带夜晚的味道。</p>
<p><strong>纽约 · 深夜披萨</strong></p>
<p>在纽约，深夜的披萨店是夜行者的集散地。一块巨大的纽约披萨片，简单折叠一下边走边吃，这是最地道的纽约深夜体验。</p>`,
    category: 'night-life',
    categoryName: '夜间生活',
    author: '夜食记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20amber%20rim%20lighting%2C%20friendly%20moody%20profile%2C%20deep%20black%20background%2C%20soft%20golden%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-5&orientation=squarish',
    publishDate: '2026-07-30',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cozy%20night%20food%20stall%20with%20warm%20steam%20and%20ambient%20lighting%2C%20street%20food%20at%20night%2C%20moody%20atmospheric%20culinary%20scene%2C%20deep%20shadows%20with%20golden%20and%20amber%20highlights%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-6&orientation=landscape',
    tags: ['深夜美食', '旅行', '城市探索'],
    featured: true,
  },
  {
    id: 'article-7',
    title: '在黑暗中写作：为什么我选择关灯创作',
    excerpt: '关掉所有的灯，只留下一块屏幕的光。这种极端的创作环境，反而让我写出了最满意的作品。',
    content: `<p>此刻，我正坐在完全黑暗的房间里，只有屏幕的光芒照亮我的脸。</p>
<p>这听起来可能有些极端，但这是我最舒服的创作状态。</p>
<p><strong>黑暗消除了视觉干扰</strong></p>
<p>在明亮的环境中，你的眼睛会不断被周围的事物吸引——墙上的画、桌上的杂物、窗外的风景。但在黑暗中，只有屏幕上的文字是唯一的光源。你的注意力被迫集中在这片光上。</p>
<p><strong>黑暗放大了内在感知</strong></p>
<p>当视觉输入的减少，其他感官会变得更加敏锐。在黑暗中，你更容易听到内心的声音，感受到情绪的细微变化。这对于需要深度思考的创作来说，是理想的状态。</p>
<p><strong>如何安全地在黑暗中工作</strong></p>
<p>将屏幕亮度调到最低，开启暖色模式。确保键盘是你能盲打的——或者在键盘上贴荧光贴纸。最重要的是，每隔半小时站起来走动一下，保护眼睛和身体。</p>
<p>在黑暗中创作，是一种独特的体验。它让你与自己的内心世界建立更深的连接。</p>`,
    category: 'creative-inspiration',
    categoryName: '创作灵感',
    author: '夜之灵感',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20golden%20rim%20lighting%2C%20artistic%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20amber%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20only%20laptop%20screen%20glow%2C%20minimal%20writing%20setup%20in%20complete%20darkness%2C%20moody%20atmospheric%20creative%20scene%2C%20deep%20black%20with%20soft%20screen%20light%2C%20cinematic%20composition&width=1200&height=600&seq=article-7&orientation=landscape',
    tags: ['创作技巧', '黑暗创作', '专注力'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '夜行者的音乐清单：十首最适合深夜聆听的歌曲',
    excerpt: '音乐是夜晚最好的伴侣。这份精心挑选的深夜歌单，陪你度过每一个不眠之夜。',
    content: `<p>有些音乐，只有在深夜听，才能真正听懂。</p>
<p><strong>深夜歌单精选</strong></p>
<p>从爵士到后摇，从古典到氛围音乐，每一首都经过精心挑选。这些音乐不需要刻意去听——让它们成为你深夜的背景，让旋律自由流淌。</p>
<p>在深夜，音乐不只是一种娱乐，更是一种疗愈。它能够触及白天无法触及的情感深处，唤醒那些被日常掩盖的记忆和感受。</p>
<p><strong>如何打造你的深夜歌单</strong></p>
<p>选择器乐为主的音乐，歌词往往会分散注意力。选择节奏舒缓但不沉闷的曲子，保持一定的能量流动。最重要的是，选择那些能让你感到安全和温暖的音乐。</p>
<p>深夜的音乐，不需要解释，只需要感受。戴上耳机，闭上眼睛，让音乐带你穿越黑夜。</p>`,
    category: 'late-night-emotion',
    categoryName: '深夜情绪',
    author: '夜之独白',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20copper%20rim%20lighting%2C%20contemplative%20moody%20profile%2C%20deep%20black%20background%2C%20soft%20warm%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-3&orientation=squarish',
    publishDate: '2026-07-25',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20headphones%20and%20vinyl%20record%20player%20at%20night%2C%20warm%20ambient%20mood%20lighting%2C%20moody%20atmospheric%20music%20listening%20scene%2C%20deep%20shadows%20with%20soft%20amber%20glow%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-8&orientation=landscape',
    tags: ['音乐', '深夜歌单', '听觉体验'],
    featured: false,
  },
  {
    id: 'article-9',
    title: '夜行者集结：如何找到你的夜间社群',
    excerpt: '夜行者不是孤独的。在线下和线上，越来越多热爱夜晚的人正在聚集。找到属于你的夜间社群，让夜晚不再孤单。',
    content: `<p>曾经，我以为自己是唯一一个热爱夜晚的"怪人"。</p>
<p>直到我找到了夜行者社群。</p>
<p><strong>线上社群：连接全世界的夜行者</strong></p>
<p>在社交媒体上，有无数以"夜"为主题的社群。从深夜读书会到夜间摄影小组，从通宵创作营到深夜电台——无论你的夜间兴趣是什么，总有一群人和你一样。</p>
<p>这些线上社群打破了地理的界限，让不同城市的夜行者可以分享各自的夜晚。</p>
<p><strong>线下聚会：真实的夜间连接</strong></p>
<p>越来越多的城市开始出现夜间主题活动：深夜书店的读书分享、午夜电影院的通宵放映、夜间跑团的星光跑、深夜咖啡馆的即兴音乐会。</p>
<p>这些活动让夜行者们从屏幕背后走出来，在真实的夜晚中相遇。</p>
<p><strong>加入夜无疆社群</strong></p>
<p>夜无疆正在建立一个全国性的夜行者社群。无论你在哪座城市，都可以找到一群理解夜晚、热爱夜晚的伙伴。夜晚不再孤单。</p>`,
    category: 'night-walker-community',
    categoryName: '夜行者社群',
    author: '深夜守望者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20bronze%20rim%20lighting%2C%20mysterious%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20golden%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-4&orientation=squarish',
    publishDate: '2026-07-22',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20warm%20cozy%20night%20gathering%20with%20fairy%20lights%20and%20lanterns%2C%20community%20meetup%20at%20night%2C%20moody%20atmospheric%20social%20scene%2C%20deep%20shadows%20with%20warm%20amber%20and%20golden%20glow%2C%20cinematic%20composition&width=1200&height=600&seq=article-9&orientation=landscape',
    tags: ['社群', '夜行者', '线下活动'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '夜晚摄影入门：用手机拍出绝美夜景',
    excerpt: '不需要专业设备，一部手机就能捕捉夜晚的美丽。这篇摄影指南教你如何在低光环境中拍出令人惊叹的夜景照片。',
    content: `<p>很多人以为拍夜景必须用专业相机。其实，你口袋里的手机已经足够强大。</p>
<p><strong>夜景拍摄的核心技巧</strong></p>
<p>保持稳定是第一要务。将手机靠在稳固的物体上，或者携带一个小型三脚架。使用夜间模式或长曝光功能，让相机有足够的时间收集光线。</p>
<p><strong>寻找光源</strong></p>
<p>夜晚不是完全没有光——街灯、霓虹灯、车灯、月光、甚至手机屏幕的光，都可以成为绝妙的拍摄元素。学会观察光线，你会在最意想不到的地方发现美。</p>
<p><strong>构图的艺术</strong></p>
<p>夜晚的构图与白天不同。利用明暗对比（明暗对比），让亮部成为画面的焦点，暗部则提供神秘感和深度。在黑暗的背景中，一束光可以讲述一个完整的故事。</p>
<p><strong>后期处理</strong></p>
<p>适当的后期可以让夜景照片更加出彩。调整曝光、对比度和色温，但注意不要过度处理——保留夜晚的自然质感才是关键。</p>`,
    category: 'creative-inspiration',
    categoryName: '创作灵感',
    author: '夜之灵感',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20golden%20rim%20lighting%2C%20artistic%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20amber%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish',
    publishDate: '2026-07-20',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20urban%20night%20street%20with%20warm%20neon%20sign%20and%20reflections%20on%20wet%20pavement%2C%20mobile%20night%20photography%20scene%2C%20moody%20atmospheric%20composition%2C%20deep%20shadows%20with%20amber%20and%20golden%20highlights%2C%20cinematic%20photography&width=1200&height=600&seq=article-10&orientation=landscape',
    tags: ['夜景摄影', '手机摄影', '创作技巧'],
    featured: false,
  },
  {
    id: 'article-11',
    title: '深夜阅读指南：最适合在夜晚读的五本书',
    excerpt: '有些书，只有在深夜读才能真正进入它的世界。这五本精选好书，是每个夜行者书架上不可或缺的精神食粮。',
    content: `<p>夜晚的阅读体验与白天截然不同。安静的环境、柔和的光线、无人打扰的专注——这是阅读的最佳状态。</p>
<p><strong>深夜选书的原则</strong></p>
<p>深夜适合读那些需要沉浸的书：文字优美的小说、引人深思的哲学随笔、或是充满想象力的科幻作品。避免读那些需要做大量笔记的实用类书籍——深夜的大脑不适合处理过于复杂的信息。</p>
<p><strong>打造你的深夜阅读角落</strong></p>
<p>一个舒适的椅子、一盏温暖的阅读灯、一条柔软的毯子——你的深夜阅读角不需要太大，但一定要让你感到安全和舒适。把手机放到另一个房间，给自己一段完整的阅读时间。</p>
<p>深夜阅读是一种奢侈的享受。在忙碌的生活中，为自己留出这段时间，让文字带你进入另一个世界。</p>`,
    category: 'late-night-emotion',
    categoryName: '深夜情绪',
    author: '夜之独白',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20copper%20rim%20lighting%2C%20contemplative%20moody%20profile%2C%20deep%20black%20background%2C%20soft%20warm%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-3&orientation=squarish',
    publishDate: '2026-07-18',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20cozy%20reading%20nook%20at%20night%20with%20warm%20reading%20lamp%2C%20open%20book%20and%20tea%20cup%2C%20moody%20atmospheric%20literary%20scene%2C%20deep%20shadows%20with%20soft%20amber%20glow%2C%20cinematic%20composition%2C%20no%20people&width=1200&height=600&seq=article-11&orientation=landscape',
    tags: ['深夜阅读', '书籍推荐', '精神生活'],
    featured: false,
  },
  {
    id: 'article-12',
    title: '通宵后的清晨：夜行者如何优雅地迎接日出',
    excerpt: '每一个通宵的夜晚，都会迎来一个特别的清晨。如何在这个特殊的时刻照顾好自己，让通宵不伤身？',
    content: `<p>凌晨五点，天空从深黑变成深蓝，然后慢慢泛出一丝橙红。</p>
<p>这是夜行者一天中最特别的时刻——日与夜的交界。</p>
<p><strong>通宵后的身体管理</strong></p>
<p>如果你选择通宵，请记住：补充水分是最重要的。咖啡因带来的清醒是暂时的，水才是身体真正需要的。吃一顿温热清淡的早餐，给身体温和的能量补充。</p>
<p><strong>欣赏日出</strong></p>
<p>不要急着睡觉。花十分钟去阳台或窗边，安静地看一次日出。这不只是一道风景，更是对自己一夜努力的仪式感。看着太阳缓缓升起，你会感到一种独特的满足感。</p>
<p><strong>通宵的频率</strong></p>
<p>不要把通宵变成习惯。一个月一到两次就足够了。身体需要规律的作息，通宵是一种偶尔的放纵，不是常态。</p>
<p>好好享受这个清晨，然后好好睡一觉。你值得这个休息。</p>`,
    category: 'night-walker-community',
    categoryName: '夜行者社群',
    author: '深夜守望者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Dark%20minimal%20portrait%20silhouette%20with%20warm%20bronze%20rim%20lighting%2C%20mysterious%20moody%20profile%2C%20deep%20charcoal%20background%2C%20soft%20golden%20edge%20light%2C%20cinematic%20portrait&width=200&height=200&seq=avatar-4&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20to%20dawn%20transition%20sky%20with%20warm%20orange%20and%20golden%20sunrise%20on%20horizon%2C%20peaceful%20morning%20after%20night%2C%20atmospheric%20landscape%20photography%2C%20deep%20shadows%20fading%20to%20warm%20light%2C%20cinematic%20composition&width=1200&height=600&seq=article-12&orientation=landscape',
    tags: ['通宵', '健康', '日出'],
    featured: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((article) => article.featured);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getRelatedArticles = (currentId: string, category: string, limit: number = 3): Article[] => {
  return articles
    .filter((article) => article.category === category && article.id !== currentId)
    .slice(0, limit);
};

export const getRecentArticles = (limit: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};